import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../core/store';
import { IGetNursingHomeRes } from '../../types/api/nursingHome/getNursingHome';

// initialize
const initialState: IGetNursingHomeRes = {
  id: 0,
  nursingHomeGroupId: 0,
  name: '',
  address: '',
  email: '',
  phoneNumber: '',
  type: 0,
  capacity: 0,
  plan: 0,
  planStatus: '',
  planDate: '',
  orderDeliveryRule: null,
  orderLayer: '',
  orderLimitDayOfWeek: '',
  orderLimitHour: 0,
  orderShippingDay: 0,
  orderShippingDayOfWeek: '',
  orderMemo: '',
  clientCode: '',
  goodTree: false,
  cdc: false,
  membershipStatus: '',
  honobonoNumber: '',
  inUseLife: false,
  inUseParamount: false,
  lifeCareFacilityId: '',
  contractDate: '',
  contractEndDate: '',
  contractStatus: '',
  scheduledFromTime: 0,
  scheduledToTime: 0,
};

// slice
export const currentNursingHomeSlice = createSlice({
  name: 'currentNursingHome',
  initialState,
  reducers: {
    setCurrentNursingHome: (state, action: PayloadAction<IGetNursingHomeRes>) => {
      Object.assign(state, action.payload);
    },
  },
});

// action
export const { setCurrentNursingHome } = currentNursingHomeSlice.actions;

// selector
export const currentNursingHomeSelector = (state: RootState) => state.currentNursingHome;
export const showLifeContentSelector = (state: RootState): boolean => {
  const { inUseLife, lifeCareFacilityId } = state.currentNursingHome;
  return inUseLife && !!lifeCareFacilityId;
};
export const isDemoContractSelector = (state: RootState): boolean => {
  const { id, contractStatus } = state.currentNursingHome;
  return id > 0 && contractStatus === 'demo';
};